import React from 'react';
import styled, { css } from 'styled-components';
import {
  maxBreakpointQuery,
  minBreakpointQuery,
  sectionMargins,
} from '../styles';
import { Container, Heading, Slider, Button } from './ui';
import ProductCard from './ProductCard';

const StyledFeaturedProducts = styled.section`
  ${sectionMargins()};
  text-align: center;
`;

const StyledSlider = styled(Slider)`
  margin: 60px -10px;

  .slick-track {
    display: flex;
  }

  .slick-slide {
    height: inherit;
  }

  ${maxBreakpointQuery.large`
    .slick-arrow.slick-next {
      right: -20px;
      transform: translate(0, -50%);
      padding-right: 0;
    }

    .slick-arrow.slick-prev {
      left: -20px;
      transform: translate(0, -50%);
      padding-left: 0;
    }
  `}

  ${maxBreakpointQuery.smedium`
    .slick-arrow.slick-next {
      right: 8px;
    }

    .slick-arrow.slick-prev {
      left: 8px;
    }
  `}
`;

const StyledItems = styled.div`
  display: grid;
  gap: 20px;
  margin: 60px 0;

  ${minBreakpointQuery.tiny`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${minBreakpointQuery.smedium`
    grid-template-columns: repeat(3, 1fr);
  `}
`;

const StyledItem = styled(ProductCard)`
  ${({ inSlider }) => {
    if (inSlider) {
      return css`
        ${minBreakpointQuery.small`
          padding-right: 10px;
          padding-left: 10px;
        `}
      `;
    }
  }}
`;

const FeaturedProducts = ({ heading, items, link, isBlogSingle }) => {
  const slidesToShow = isBlogSingle ? 3 : 4;

  const sliderOptions = {
    arrows: true,
    autoplay: false,
    dots: false,
    adaptiveHeight: true,
    slidesToShow: slidesToShow,
    responsive: [
      {
        breakpoint: 1120,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 870,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    items &&
    items.length > 0 && (
      <StyledFeaturedProducts>
        <Container narrow={items.length < 4}>
          <Heading>{heading}</Heading>
          {items.length >= slidesToShow ? (
            <StyledSlider {...sliderOptions}>
              {items.map(item => (
                <StyledItem
                  key={item.id}
                  title={item.title}
                  handle={item.handle}
                  collections={item.collections}
                  featuredImage={item.featuredImage}
                  colour={item.colour}
                  filling={item.filling}
                  tags={item.tags}
                  priceRangeV2={item.priceRangeV2}
                  variants={item.variants}
                  isBestSeller={item.isBestSeller}
                  isAntiAllergy={item.isAntiAllergy}
                  isInSale={item.isInSale}
                  isRetailProduct={item.isRetailProduct}
                  inSlider={true}
                />
              ))}
            </StyledSlider>
          ) : (
            <StyledItems>
              {items.map(item => (
                <StyledItem
                  key={item.id}
                  title={item.title}
                  handle={item.handle}
                  collections={item.collections}
                  featuredImage={item.featuredImage}
                  filling={item.filling}
                  tags={item.tags}
                  priceRangeV2={item.priceRangeV2}
                  variants={item.variants}
                  isBestSeller={item.isBestSeller}
                  isAntiAllergy={item.isAntiAllergy}
                  isInSale={item.isInSale}
                  isRetailProduct={item.isRetailProduct}
                />
              ))}
            </StyledItems>
          )}
        </Container>
        {link && <Button to={link.page}>{link.text}</Button>}
      </StyledFeaturedProducts>
    )
  );
};

export default FeaturedProducts;
